var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroItemStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 2C1.82272 2 1.375 2.44772 1.375 3V19.75C1.375 20.3023 1.82272 20.75 2.375 20.75H21.625C22.1773 20.75 22.625 20.3023 22.625 19.75V6.30882C22.625 5.75654 22.1773 5.30882 21.625 5.30882H13.3738C13.1123 5.30882 12.8613 5.20639 12.6744 5.02349L9.87676 2.28534C9.68988 2.10243 9.43879 2 9.17729 2H2.375ZM4.5 15.5H19.5V13.5H4.5V15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroItemStatus);
export default __webpack_public_path__ + "static/media/hero-item-status.96afa9b026236a10915461982dd93b21.svg";
export { ForwardRef as ReactComponent };